import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=2dc3674d&scoped=true"
import script from "./CCheckbox.vue?vue&type=script&lang=js"
export * from "./CCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CCheckbox.vue?vue&type=style&index=0&id=2dc3674d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc3674d",
  null
  
)

export default component.exports